import {useGetService} from "@project/application/engineering/services";
import {useContainerBreakpoint} from "@project/layouts";
import {routes} from "@project/router";
import {Navigate, createFileRoute, useParams} from "@tanstack/react-router";
import {useRef} from "react";

import {Route as ServiceRoute} from "./route";

export const Route = createFileRoute("/_app/engineering/services/$serviceId/")({
  component: IndexRouteComponent,
});

function IndexRouteComponent() {
  const {serviceId} = useParams({strict: false}) as {serviceId: string};
  const {includeDeleted} = ServiceRoute.useSearch();
  const {data: service} = useGetService(serviceId, includeDeleted);
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useContainerBreakpoint(ref);

  if (isDesktop && service?.serviceId === serviceId) {
    if (service.compositionKind === "COMPOSITE")
      return (
        <Navigate
          replace
          params={{serviceId}}
          search={{includeDeleted}}
          to={routes.engineering.services.service().composition()}
        />
      );
    return (
      <Navigate
        replace
        params={{serviceId}}
        search={{
          page: 1,
          perPage: 10,
          state: "ACTIVE",
          sortKey: "supplierId",
          sortDir: "asc",
          includeDeleted,
        }}
        to={routes.engineering.services.service().offers()}
      />
    );
  }

  return <div ref={ref} className="h-full w-full" />;
}
